import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../app/store';
import { Project } from 'types/data/project.t';

// Define a type for the slice state
interface CurrentProjectState {
  value: Project | null;
}

// Define the initial state using that type
const initialState: CurrentProjectState = {
  value: null
};

export const currentProjectSlice = createSlice({
  name: 'currentProject',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateCurrentProject: (state, action: PayloadAction<Project | null>) => {
      state.value = action.payload;
    },
    removeMemberFromCurrentProject: (state, action: PayloadAction<number>) => {
      if (state.value) {
        state.value.members = state.value.members.filter(member => member.id !== action.payload);
      }
    }
  }
});

export const { updateCurrentProject, removeMemberFromCurrentProject } = currentProjectSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectCurrentProject = (state: RootState) => state.currentProject.value;

export default currentProjectSlice.reducer;
